import { render, staticRenderFns } from "./ClinicA.vue?vue&type=template&id=29ac5df4&scoped=true"
import script from "./ClinicA.vue?vue&type=script&lang=js"
export * from "./ClinicA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ac5df4",
  null
  
)

export default component.exports